<ul
  *ngIf="item"
  class="menu">
  <li
    *ngIf="!item.is_main"
    (click)="makeMain(item.id)"
    class="menu__item">
    {{'SAVED_CARD_PAGE.CONTEXT_MENU.MAKE_MAIN' | translate}}
  </li>
  <ng-container
    *appHasAccess="['CARDS_BLOCK']">
    <li
      *ngIf="!item.is_blocked"
      (click)="blockedCard(item.id)"
      class="menu__item">
      {{'SAVED_CARD_PAGE.CONTEXT_MENU.BLOCK' | translate}}
    </li>
  </ng-container>

  <ng-container
    *appHasAccess="['CARDS_BLOCK']">
    <li
      *ngIf="item.is_blocked"
      (click)="activatedCard(item.id)"
      class="menu__item">
      {{'SAVED_CARD_PAGE.CONTEXT_MENU.ACTIVATE' | translate}}
    </li>
  </ng-container>

  <li
    *appHasAccess="['CARDS_DELETE']"
    (click)="deleteCard(item)"
    class="menu__item">
    {{'SAVED_CARD_PAGE.CONTEXT_MENU.DELETE' | translate}}
  </li>
</ul>
